import gql from 'graphql-tag';

export const GET_ALL_LICENSES = gql`
    {
        licenseList {
            id
            email
            username
            status
            allowedChannels
            allowedSiteinis
            usedChannels
            usedSiteinis
            created_at
            server {
                hostname
                batch {
                    name
                    color
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/licenses/all.js